import { render } from "./wuhanApportion.vue?vue&type=template&id=842660de"
import script from "./wuhanApportion.vue?vue&type=script&lang=js"
export * from "./wuhanApportion.vue?vue&type=script&lang=js"

import "./wuhanApportion.vue?vue&type=style&index=0&id=842660de&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\sport.yanhuotiyu.com焱火pc端web网站\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__